import {
  useGetCheckouts,
  useUpdateIsActiveCheckout,
} from "@yuno/dashboard-api-mfe";
import { useAccount, useClearFilterEvent } from "@yuno/dashboard-container-mfe";
import { useMemo } from "react";
import { reset } from "yargs";

export const useConditions = () => {
  const account = useAccount();
  const { data, status, isLoading, refetch, isFetching, reset } =
    useGetCheckouts({
      accountCode: account?.code,
    });

  const { mutate: mutateCheckout, status: statusMutateCheckout } =
    useUpdateIsActiveCheckout();

  const _extractType = (type: "PAYMENT_METHOD" | "ENROLLMENT") => {
    return (
      data?.[0]?.payment_methods
        ?.filter((el) => {
          if (type === "ENROLLMENT") return el.has_enrollment;
          if (type === "PAYMENT_METHOD") return !el.has_enrollment;
        })
        ?.map((el, key) => ({
          ...el,
          order_to_show: key,
        })) || []
    );
  };

  return {
    checkout: data?.[0] || {},
    paymentMethods: useMemo(() => _extractType("PAYMENT_METHOD"), [status]),
    enrollment: useMemo(() => _extractType("ENROLLMENT"), [status]),
    isLoading: isLoading || isFetching,
    status,
    mutateCheckout,
    statusMutateCheckout,
    refetch,
  };
};
